import { render, staticRenderFns } from "./CaptureNewInventoryNote.vue?vue&type=template&id=6daf1152&scoped=true"
import script from "./CaptureNewInventoryNote.vue?vue&type=script&lang=js"
export * from "./CaptureNewInventoryNote.vue?vue&type=script&lang=js"
import "./CaptureNewInventoryNote.vue?vue&type=style&index=0&id=6daf1152&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6daf1152",
  null
  
)

export default component.exports